import ReferenceChart from "@/components/ReferenceChart";

const ROWS = [
  { key: "dopamine", big: "DA", small: "CNS", name: "Dopamine", group: "Monoamines", tag: "Excitatory·mostly", note: "Reward, motor control, motivation. ↓ in Parkinson's; ↑ in schizophrenia." },
  { key: "norepi", big: "NE", small: "CNS/PNS", name: "Norepinephrine", group: "Monoamines", tag: "Excitatory", note: "Arousal, fight-or-flight. Locus coeruleus. Depression when low." },
  { key: "epi", big: "Epi", small: "adrenal", name: "Epinephrine", group: "Monoamines", tag: "Excitatory", note: "Hormonal & neurotransmitter. Adrenal medulla. Increases HR, glucose." },
  { key: "serotonin", big: "5-HT", small: "CNS/GI", name: "Serotonin", group: "Monoamines", tag: "Inhibitory·mostly", note: "Mood, sleep, appetite. From tryptophan. SSRIs boost it." },
  { key: "histamine", big: "H", small: "CNS", name: "Histamine", group: "Monoamines", tag: "Excitatory", note: "Wakefulness, allergic response. Antihistamines cause drowsiness." },
  { key: "ach", big: "ACh", small: "CNS/PNS", name: "Acetylcholine", group: "Small molecule", tag: "Excit/Inhib", note: "NMJ, autonomic ganglia, memory. ↓ in Alzheimer's." },
  { key: "glutamate", big: "Glu", small: "CNS", name: "Glutamate", group: "Amino acid", tag: "Excitatory", note: "PRIMARY excitatory in CNS. NMDA/AMPA receptors. Learning + LTP." },
  { key: "gaba", big: "GABA", small: "CNS", name: "GABA", group: "Amino acid", tag: "Inhibitory", note: "PRIMARY inhibitory in adult CNS. Benzos + alcohol potentiate it." },
  { key: "glycine", big: "Gly", small: "spinal", name: "Glycine", group: "Amino acid", tag: "Inhibitory", note: "Inhibitory in brainstem + spinal cord. Strychnine blocks it." },
  { key: "endorphins", big: "END", small: "CNS", name: "Endorphins", group: "Peptides", tag: "Inhibitory", note: "Endogenous opioids. Pain relief, runner's high. µ-opioid receptor." },
  { key: "substance-p", big: "SP", small: "CNS/PNS", name: "Substance P", group: "Peptides", tag: "Excitatory", note: "Pain transmission (nociception). NK1 receptor." },
  { key: "no", big: "NO", small: "CNS/PNS", name: "Nitric Oxide", group: "Gas", tag: "Signaling", note: "Gaseous NT. Vasodilation, smooth muscle. Retrograde messenger." },
];

const GROUP_COLORS = {
  Monoamines: { bg: "#f3ede1", text: "#7a5b2a", pill: "#c98a3b" },
  "Small molecule": { bg: "#efe4d8", text: "#6a4a2f", pill: "#a5754a" },
  "Amino acid": { bg: "#e8f1e5", text: "#3d5a2f", pill: "#7ba55c" },
  Peptides: { bg: "#e5edf5", text: "#2d4a6f", pill: "#4f7d8a" },
  Gas: { bg: "#f6e5e5", text: "#7a3a3a", pill: "#c95e5e" },
};

export default function NeurotransmittersChart() {
  return (
    <ReferenceChart
      title="Neurotransmitter Reference"
      subtitle="The neurotransmitters the MCAT tests, grouped by chemistry. Excitatory (glutamate) vs inhibitory (GABA) is a favorite tested distinction."
      sourceChart="neurotransmitters"
      rows={ROWS}
      groupColors={GROUP_COLORS}
      deckMapper={(r) => ({
        front: `${r.name} (${r.big})`,
        back: `${r.group}. ${r.tag}. ${r.note}`,
        meta: { key: r.key, group: r.group },
      })}
      footer={
        <div className="grid md:grid-cols-2 gap-3">
          <div>
            <b>Excitatory vs Inhibitory:</b> Glutamate = main excitatory, GABA
            = main inhibitory (in adult CNS). Most others are excitatory OR
            inhibitory depending on receptor type.
          </div>
          <div>
            <b>Disease mnemonics:</b> ↓ Dopamine → Parkinson's · ↑ Dopamine →
            Schizophrenia · ↓ Serotonin/NE → Depression · ↓ ACh → Alzheimer's
            · ↓ GABA → Anxiety/seizures.
          </div>
        </div>
      }
    />
  );
}
